// Copyright 2022 Merit International Inc. All Rights Reserved

import { GenericInfoScreen } from "../GenericInfoScreen";
import React from "react";

export const ClaimApprovedScreen = () => (
  <GenericInfoScreen heading="Review a claim" image="document" text="Claim approved" />
);
